<template>

    <div class="tab-pane active">
    Help
    </div>
</template>



<script>
	export default {
		name: "Help"
	}
</script>

<style scoped>

</style>